var React = require('react');

function TemplatesInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.0645 7V1H2.06445V7V9V20H19.0645V9V7ZM17.0645 7V3H4.06445V7H6.06445V9H4.06445V18H17.0645V9H15.0645V7H17.0645ZM10.0645 7H7.06445V9H10.0645V7ZM11.0645 7H14.0645V9H11.0645V7ZM6.06445 11H15.0645V13H6.06445V11ZM12.0645 14H6.06445V16H12.0645V14ZM21.0645 23H22.0645V4H20.0645V21H5.06445V23H20.0645H21.0645Z","fill":"#C7D5D9"}));
}

TemplatesInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","role":"img","aria-label":""};

module.exports = TemplatesInline;

TemplatesInline.default = TemplatesInline;
